export enum StagePhase {
  firstStage = "firstStage",
  secondStage = "secondStage",
  thirdStage = "thirdStage",
}
